
import React from 'react';
import { Check, X } from 'lucide-react';
import { PasswordRequirements as PasswordReqs } from '@/utils/passwordUtils';

interface PasswordRequirementsProps {
  requirements: PasswordReqs;
  isVisible: boolean;
}

const PasswordRequirements = ({ requirements, isVisible }: PasswordRequirementsProps) => {
  if (!isVisible) return null;

  const requirementsList = [
    { key: 'minLength', text: 'At least 8 characters', met: requirements.minLength },
    { key: 'hasUppercase', text: 'One uppercase letter', met: requirements.hasUppercase },
    { key: 'hasLowercase', text: 'One lowercase letter', met: requirements.hasLowercase },
    { key: 'hasNumber', text: 'One number', met: requirements.hasNumber },
    { key: 'hasSpecialChar', text: 'One special character (!@#$%^&*)', met: requirements.hasSpecialChar }
  ];

  return (
    <div className="mt-2 p-3 bg-gray-800 border border-gray-600 rounded text-sm">
      <p className="text-white font-medium mb-2">Password Requirements:</p>
      <ul className="space-y-1">
        {requirementsList.map((req) => (
          <li key={req.key} className="flex items-center gap-2">
            {req.met ? (
              <Check className="h-4 w-4 text-green-500" />
            ) : (
              <X className="h-4 w-4 text-red-500" />
            )}
            <span className={req.met ? 'text-green-400' : 'text-gray-300'}>
              {req.text}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
